/**
 * Global string constants.
 */
export enum AppConstants {
  EmailSheepGeneticsInfo = 'info@sheepgenetics.org.au',
  CalendarDateFormat = 'DD/MM/YYYY',
  DateFormat = 'DD MMM YYYY',
  MLAtoolsUrl = 'http://sgsearch.sheepgenetics.org.au/Tools/Index.aspx',
  FooterLegal = 'Sheep Genetics ASBVs are calculated from raw data collected by breeders and accredited Sheep Genetics operators. Sheep Genetics (a program of Meat & Livestock Australia) does not oversee or audit the collection of this data therefore Sheep Genetics does not accept any responsibility for the accuracy of the information in this document.',
}
